import React from "react"
import PropTypes from "prop-types"
import styles from "./button.module.scss"

function Button({ buttonText, buttonStyle, link }) {
  return (
    <a
      className={buttonStyle ? buttonStyle : styles.buttonStyle}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      {buttonText}
      <span className={styles.arrow}>→</span>
    </a>
  )
}

Button.propTypes = {
  buttonText: PropTypes.string.isRequired,
  link: PropTypes.string,
  buttonStyle: PropTypes.string,
}

export default Button
